/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {EnvironmentalBenefitValueEditor} from "./EnvironmentalBenefitValueEditor";
import React from "react";

export function MilestoneProgramEnvironmentalBenefitsTargetValueEditor(props) {
	let environmentalBenefitId = -1;
	let thisId = props?.Data?.milestoneId || props?.Data?._tempId;

	if (props?.RootData?.ProgramEnvironmentalBenefits) {
		props?.RootData?.ProgramEnvironmentalBenefits.forEach((x) => {
			if (x?.Milestones && x?.Milestones.some((y) => y?.milestoneId == thisId)) {
				environmentalBenefitId = x?.environmentalBenefitId;
			}
		});
	}

	return <EnvironmentalBenefitValueEditor
		environmentalBenefitId={environmentalBenefitId}
		{...props}
	/>
}